import React from "react";
import { FileText, Upload, ShieldCheck, Send, Trophy } from "lucide-react";
import { C, Pill, Step, ArrowChevron } from "./shared";

export default function HowItWorksStudents() {
  return (
    <section className="bg-white">
      <div className="max-w-7xl mx-auto px-6 py-16 md:py-20">
        <div className="text-center max-w-2xl mx-auto">
          <Pill color={C.orange}>How it works</Pill>
          <h2 className="font-display font-black text-3xl md:text-5xl mt-3 tracking-tight" style={{ color: C.navyDeep }}>
            Five steps. <span style={{ color: C.green }}>One career launch.</span>
          </h2>
        </div>
        <div className="mt-12 flex flex-wrap items-start justify-center gap-y-8 gap-x-2 md:gap-x-4">
          <Step n="1" icon={FileText}    title="Create Profile"   color={C.green} />
          <ArrowChevron />
          <Step n="2" icon={Upload}      title="Upload Resume"    color={C.navy} />
          <ArrowChevron />
          <Step n="3" icon={ShieldCheck} title="Verify Skills"    color={C.purple} />
          <ArrowChevron />
          <Step n="4" icon={Send}        title="Apply to Jobs"    color={C.orange} />
          <ArrowChevron />
          <Step n="5" icon={Trophy}      title="Get Hired & Grow" color={C.green} />
        </div>
      </div>
    </section>
  );
}
